import request from '../utils/request';
export function postUserFinanceInfo (data){
    return request({
        url: "/wxmanager/finance/computeUserFinanceInfo",
        method:'post',
        data,
    });
}